import React, { Fragment, useState, useCallback, useMemo } from 'react'
import { connect } from 'react-redux'
import Popup from 'reactjs-popup'
import Loader from 'react-loader-spinner'
import * as actions from '../redux/actions'
import rp from 'request-promise-native'
import { uriV2 } from './defaultProps'
import '../styles/services/ShopListChangeStatusPopup.css'
import { FiCheck, FiX } from 'react-icons/fi'

const styles = {
  popupContentStyle: {
    maxWidth: '400px',
    width: '100%',
    margin: 'auto',
    backgroundColor: 'white',
    borderRadius: '12px',
    position: 'relative'
  },
  popupOverlayStyle: {
    padding: '0 24px'
  }
}

const rejectReasons = [
  'Acho que o modelo não me favorece.',
  'O valor da peça está acima do meu orçamento.',
  'Gostei da peça, mas não tinha na minha numeração.',
  'Outro motivo.'
]

const ShopListChangeStatusPopup = props => {
  const [showPopup, setShowPopup] = useState(true)
  const [loading, setLoading] = useState(false)
  const [rejectionReasonOption, setRejectReasonOption] = useState(null)
  const [rejectionReasonText, setRejectionReasonText] = useState('')

  // type = 0 => no form errors in popup
  // type = 1 => empty rejectReasonOption
  // type = 2 => empty rejectReasonText
  const [errorType, setErrorType] = useState(0)

  const popupType = useMemo(() => props.popupType, [props.popupType])
  const templateId = useMemo(() => props.templateId, [props.templateId])
  const rejectionReasonResponse = useMemo(() => {
    if (rejectionReasonOption === 3) {
      return rejectionReasonText
    }
    return rejectReasons[rejectionReasonOption]
  }, [rejectionReasonOption, rejectionReasonText])

  const noEvaluation = useCallback(() => {
    setShowPopup(false)
    props.closePopup()
  }, [])

  const saveStatusChange = useCallback(async status => {
    if (status === 'rejected') {
      if (rejectionReasonOption === null) {
        return setErrorType(1)
      }

      if (rejectionReasonOption === 3 && !rejectionReasonResponse) {
        return setErrorType(2)
      }
    }

    setLoading(true)

    const data = {
      status,
      rejectionReason: rejectionReasonResponse
    }

    try {
      const response = await rp({
        uri: `${uriV2}/user/media/shoplist/template/${templateId}/status/change`,
        method: 'PATCH',
        headers: {
          Authorization: props.token
        },
        body: data,
        json: true
      })
      props.setUserAttribute({ shopListTemplate: response })
    } catch (err) {
      console.error('Erro ao salvar as informações: ', err)
      if (err.statusCode === 400) {
        window.alert(`Erro de validação.`)
      } else {
        window.alert(`Erro de conexão.`)
      }
    } finally {
      props.closePopup()
    }
  }, [props.token, rejectionReasonResponse])

  const isRejectionChecked = useCallback(selectedOption => {
    return rejectionReasonOption === selectedOption
  }, [rejectionReasonOption])

  const renderLoader = useCallback(() => {
    return (
      <div className='popup-content-container'>
        <Loader
          type='TailSpin'
          color='#6d357b'
          height='50'
          width='50'
        />
      </div>
    )
  }, [])

  const setReason = useCallback(event => {
    setRejectReasonOption(event)
  }, [])

  const renderPopupRemoveFeedbackContent = () => {
    return (
      <div className='popup-content-container'>
        <div className='popup-header-close'>
          <FiX size={20} color='var(--primary)'
            onClick={() => {
              setShowPopup(false)
              props.closePopup()
            }}
          />
        </div>
        <p className='popup-title'>
          Deseja realmente remover a avaliação?
        </p>
        <p className='popup-paragraph'>
          Você tem certeza de que deseja remover a resposta que enviou para sua consultora? Se fizer isso, ela não saberá se você comprou ou não o produto! Você pode mandar uma nova avaliação do mesmo produto a qualquer momento.
        </p>
        <div className='buttons-container'>
          <div className='popup-accept-button' id='button-send'
            onClick={() => noEvaluation()}
          >
            Manter a avaliação
          </div>
          <div className='popup-not-change-status-button' id='button-no-evaluation'
            onClick={() => saveStatusChange('pending')}
          >
            Remover a avaliação
          </div>
        </div>
      </div>
    )
  }

  const renderPopupBoughtContent = () => {
    return (
      <div className='popup-content-container'>
        <div className='popup-header-close'>
          <FiX size={20} color='var(--primary)'
            onClick={() => {
              setShowPopup(false)
              props.closePopup()
            }}
          />
        </div>
        <p className='popup-title'>
          Que bom que deu certo!
        </p>
        <p className='popup-paragraph'>
          Clique no botão abaixo e sua consultora vai saber que você comprou o produto!
        </p>

        <div className='buttons-container'>
          <div className='popup-accept-button' id='button-send'
            onClick={() => saveStatusChange('bought')}
          >
            Comprei o produto!
          </div>
          <div className='popup-not-change-status-button' id='button-no-evaluation'
            onClick={() => noEvaluation()}
          >
            Não comprei ainda
          </div>

        </div>
      </div>
    )
  }

  const renderPopupRejectionContent = () => {
    return (
      <div className='popup-content-container'>
        <div className='popup-header-close'>
          <FiX size={20} color='var(--primary)'
            onClick={() => {
              setShowPopup(false)
              props.closePopup()
            }}
          />
        </div>
        <p className='popup-title'>
          Não comprou o produto?
        </p>
        <p className='popup-paragraph'>
        Não tem problema! Conte para a sua consultora o motivo, para que ela possa lhe fazer uma indicação mais adequada:
        </p>
        <div className='popup-checkbox'>
          {rejectReasons.map((rejectReason, index) => {
            return (
              <div className='popup-checkbox-container'
                key={index} onClick={() => {
                  setReason(index)
                  setErrorType(0)
                }} style={{marginBottom: 4}}>
                <div className={`popup-checkbox-circle ${isRejectionChecked(index) ? 'popup-checkbox-checked' : ''} ${errorType === 1 ? 'popup-checkbox-error' : ''}`}>
                  {isRejectionChecked(index) && <FiCheck color='white' size={15} className='popup-checkbox-icon' />}
                </div>
                <p className='popup-checkbox-label'>{rejectReason}</p>
              </div>
            )
          })}
          {errorType === 1 && <p className='popup-checkbox-error-text'>Por favor, selecione uma opção</p>}
        </div>
        {rejectionReasonOption === 3 &&
          <textarea placeholder='Digite o motivo'
            className={`popup-input ${errorType === 2 ? 'popup-input-error' : ''}`} type='text' id='evaluation-text' name='text-evaluation' maxLength='255' rows='3'
            onChange={event => {
              setErrorType(0)
              setRejectionReasonText(event.target.value)
            }} />
        }
        {errorType === 2 && <p className='popup-input-error-text'>Por favor, preencher este campo</p>}
        <div className='buttons-container'>
          <div className='popup-accept-button' id='button-send'
            onClick={() => saveStatusChange('rejected')}
          >
            Enviar Avaliação
          </div>
          <div className='popup-not-change-status-button' id='button-no-evaluation'
            onClick={() => noEvaluation()}
          >
            Não quero avaliar
          </div>
        </div>
      </div>
    )
  }

  const resolvePopupTypeContent = popupType => {
    if (popupType === 'rejection') {
      return renderPopupRejectionContent()
    }
    if (popupType === 'bought') {
      return renderPopupBoughtContent()
    }
    return renderPopupRemoveFeedbackContent()
  }

  const renderPopup = () => {
    return (
      <Popup
        open={showPopup}
        position='right center'
        contentStyle={styles.popupContentStyle}
        overlayStyle={styles.popupOverlayStyle}
        closeOnDocumentClick={false}
      >
        <div className='modal'
        >
          {loading ? renderLoader()
            : resolvePopupTypeContent(popupType)
          }
        </div>
      </Popup>
    )
  }

  return (
    <Fragment>
      {props.children}
      {showPopup && renderPopup()}
    </Fragment>
  )
}

const mapSateToProps = state => ({
  token: state.userReducer.token,
  user: state.userReducer.user,
  lastShow: state.evaluationReducer.lastShow,
  display: state.evaluationReducer.display
})

export default connect(
  mapSateToProps,
  actions
)(ShopListChangeStatusPopup)



// WEBPACK FOOTER //
// ./src/services/ShopListChangeStatusPopup.js